let Vue = require('vue');
let portalTemplate = require('templates/portals/index/portal-template.html');

Vue.component('portal-template', {
    twoWay: true,
    template: portalTemplate,
    props: {
        portal : {
            type : Object
        }
    },
    data: () => ({
        showModal: false
    }),
    methods: {
        portalType(portal){
            return portal.free ? 'Gratuito' : 'Pago';
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/portals/index/portal-template.js